module.exports = __webpack_public_path__ + "1f0d2702b485cd1a3452938a8757fae6.svg";